export const isAdmin = (permission?: string) => {
  return (
    permission &&
    ['dentist', 'office_admin'].some((item) => item === permission)
  );
};
